import hres31xLabels from 'assets/labels/hres31x'
import faker from 'faker'
import moment from 'moment'

export const mocker = {
  labels () {
    return {
      labels: hres31xLabels
    }
  },
  detailIndex () {
    let mockIndex = {
      namtitlt: 'Mr.',
      namfirstt: faker.name.firstName(),
      namlastt: faker.name.lastName(),
      codcomp: faker.company.companyName(),
      codpos: faker.name.jobType()
    }
    return {
      index: mockIndex
    }
  },
  detailTab1 () {
    let mockTab1 = {
      codsex: faker.lorem.word(),
      dteempdb_y: Math.floor((Math.random() * 100) + 1),
      dteempdb_m: Math.floor((Math.random() * 11) + 1),
      tchildrn: Math.floor((Math.random() * 10) + 1),
      stamarry: faker.lorem.word(),
      codedlv: faker.lorem.word(),
      codinst: faker.company.companyName(),
      desnoffi: faker.company.companyName(),
      numtelof: Math.floor((Math.random() * 900) + 1),
      staemp: faker.lorem.word(),
      codempmt: moment().format('DD/MM/YYYY'),
      typpayroll: faker.lorem.word(),
      dteempmt_y: Math.floor((Math.random() * 100) + 1),
      dteempmt_m: Math.floor((Math.random() * 11) + 1),
      dteempmt: moment().format('DD/MM/YYYY'),
      dteoccup: moment().format('DD/MM/YYYY'),
      dteefpos: moment().format('DD/MM/YYYY'),
      amtincom: Math.floor((Math.random() * 100000) + 1)
    }
    return {
      tab1: mockTab1
    }
  },
  detailTab2_19 () {
    let i
    let mockTab2 = {
      // subtopic1
      codblood: faker.lorem.word(),
      v_weight: Math.floor((Math.random() * 100) + 30),
      v_high: Math.floor((Math.random() * 100) + 110),
      codrelgn: faker.lorem.word(),
      codorgin: faker.lorem.word(),
      codnatnl: faker.lorem.word(),
      dteempdb: moment().format('DD/MM/YYYY'),
      coddomcl: faker.address.state(),
      stamarry: faker.lorem.word(),
      stamilit: faker.lorem.word(),
      numappl: Math.floor((Math.random() * 500) + 10),
      numprmid: Math.floor((Math.random() * 60000) + 10),
      dteprmst: moment().format('DD/MM/YYYY'),
      dteprmen: moment().format('DD/MM/YYYY'),
      // subtopic2
      numoffid: Math.floor((Math.random() * 9000000000000) + 1),
      adrissue: faker.address.city(),
      codprovi: faker.address.state(),
      dteoffid: moment().format('DD/MM/YYYY'),
      numpasid: Math.floor((Math.random() * 9000000000000) + 1),
      dtepasid: moment().format('DD/MM/YYYY'),
      // subtopic3
      numlicid: Math.floor((Math.random() * 900000000000) + 1),
      dtelicid: moment().format('DD/MM/YYYY'),
      // subtopic4
      adrregt: faker.address.streetAddress(),
      dessubdistr: faker.address.streetName(),
      desdistr: faker.address.city(),
      desprovr: faker.address.state(),
      descntyr: faker.address.country(),
      codpostr: faker.address.zipCode(),
      // subtopic5
      adrconte: faker.address.streetAddress(),
      dessubdistc: faker.address.streetName(),
      desdistc: faker.address.city(),
      desprovc: faker.address.state(),
      descntyc: faker.address.country(),
      codpostc: faker.address.zipCode(),
      numtelec: faker.phone.phoneNumber()
    }

    let mockTab3 = {
      dteempmt: moment().format('DD/MM/YYYY'),
      codcomp: faker.name.jobArea(),
      codpos: faker.name.jobTitle(),
      codbrlc: faker.address.cityPrefix(),
      codempmt: faker.lorem.word(),
      typpayroll: faker.lorem.word(),
      typemp: faker.lorem.word(),
      codcalen: faker.lorem.word(),
      codjob: faker.lorem.word(),
      jobgrad: faker.lorem.word(),
      codgrpgl: faker.lorem.word(),
      dteefstep: faker.lorem.word(),
      qtydtepr: Math.floor((Math.random() * 120) + 1),
      qtyyear: Math.floor((Math.random() * 50) + 1),
      qtymonth: Math.floor((Math.random() * 11) + 1),
      email: faker.lorem.word(),
      numlvl: faker.lorem.word(),
      dteeffex: moment().format('DD/MM/YYYY'),
      dteeflvl: moment().format('DD/MM/YYYY'),
      dteoccup: moment().format('DD/MM/YYYY'),
      numreqst: Math.floor((Math.random() * 9000) + 1),
      staemp: faker.lorem.word(),
      flgatten: faker.lorem.word(),
      dteefpos: moment().format('DD/MM/YYYY'),
      numtelof: Math.floor((Math.random() * 900) + 1)
    }

    let mockTab4IncomeRows = []
    const mockTab4IncomeTotal = 10
    for (i = 1; i <= mockTab4IncomeTotal; i++) {
      mockTab4IncomeRows.push({
        code: faker.address.stateAbbr(),
        desc_income: faker.lorem.word(),
        unit: faker.lorem.word(),
        qtyincome: faker.lorem.word(),
        desc_codecurr: faker.lorem.word()
      })
    }

    let mockTab4Detail = {
      hour_income: faker.lorem.word(),
      day_income: faker.lorem.word(),
      month_income: faker.lorem.word()
    }

    let mockTab5Detail = {
      // subtopic1
      numtaxid: Math.floor((Math.random() * 900000000) + 1),
      numsaid: Math.floor((Math.random() * 9000000) + 1),
      tax_deduct: faker.lorem.word(),
      frsmemb: moment().format('DD/MM/YYYY'),
      tax_payment: faker.lorem.word(),
      codcln: Math.floor((Math.random() * 900) + 1),
      // subtopic2
      codbank1: faker.lorem.word(),
      numbank: Math.floor((Math.random() * 900000000) + 1),
      amtbank: Math.floor((Math.random() * 90) + 1),
      codbank2: faker.lorem.word(),
      numbank2: Math.floor((Math.random() * 90) + 1),
      // subtopic3
      dtebf: moment().format('DD/MM/YYYY'),
      amtincbf: Math.floor((Math.random() * 9000000) + 1),
      amtpf: Math.floor((Math.random() * 9000000) + 1),
      amttaxbf: Math.floor((Math.random() * 9000000) + 1),
      amtsaid: Math.floor((Math.random() * 9000000) + 1),
      dtebfsp: moment().format('DD/MM/YYYY'),
      amtincsp: Math.floor((Math.random() * 9000000) + 1),
      amtpfsp: Math.floor((Math.random() * 9000000) + 1),
      amttaxsp: Math.floor((Math.random() * 9000000) + 1),
      amtsasp: Math.floor((Math.random() * 9000000) + 1),
      dteupd: moment().format('DD/MM/YYYY'),
      coduser: faker.lorem.word(),
      // in table
      qtychedu: Math.floor((Math.random() * 9) + 1),
      qtychned: Math.floor((Math.random() * 9) + 1)
    }

    let mockTab5TaxExemptionRows = []
    const mockTab5TaxExemptionTotal = 5
    for (i = 1; i <= mockTab5TaxExemptionTotal; i++) {
      mockTab5TaxExemptionRows.push({
        coddeduct: faker.address.stateAbbr(),
        desc_coddeduct: faker.lorem.sentence(),
        v_amtdeduct: Math.floor((Math.random() * 1000000) + 1),
        v_amtspded: Math.floor((Math.random() * 100000) + 1)
      })
    }

    let mockTab5TaxDeductionRows = []
    const mockTab5TaxDeductionTotal = 5
    for (i = 1; i <= mockTab5TaxDeductionTotal; i++) {
      mockTab5TaxDeductionRows.push({
        coddeduct: faker.address.stateAbbr(),
        desc_coddeduct: faker.lorem.sentence(),
        v_amtdeduct: Math.floor((Math.random() * 1000000) + 1),
        v_amtspded: Math.floor((Math.random() * 100000) + 1)
      })
    }

    let mockTab5OtherDeductionRows = []
    const mockTab5OtherDeductionTotal = 5
    for (i = 1; i <= mockTab5OtherDeductionTotal; i++) {
      mockTab5OtherDeductionRows.push({
        coddeduct: faker.address.stateAbbr(),
        desc_coddeduct: faker.lorem.sentence(),
        v_amtdeduct: Math.floor((Math.random() * 1000000) + 1),
        v_amtspded: Math.floor((Math.random() * 100000) + 1)
      })
    }

    let mockTab6EducationRows = []
    const mockTab6EducationTotal = Math.floor((Math.random() * 5) + 1)
    for (i = 1; i <= mockTab6EducationTotal; i++) {
      mockTab6EducationRows.push({
        numseq: i,
        codedlv: faker.lorem.words(),
        coddglv: faker.lorem.words(),
        codmajsb: faker.lorem.words(),
        codinst: faker.lorem.words(),
        codminsb: faker.lorem.words(),
        codcount: faker.lorem.words(),
        numgpa: Math.floor((Math.random() * 3) + 1),
        stayear: Math.floor((Math.random() * 2015) + 1),
        flgeduc: faker.lorem.word()
      })
    }

    let mockTab7ExpWorkRows = []
    const mockTab7ExpWorkTotal = Math.floor((Math.random() * 5) + 1)
    for (i = 1; i <= mockTab7ExpWorkTotal; i++) {
      mockTab7ExpWorkRows.push({
        numseq: i,
        desnoffi: faker.lorem.words(),
        deslstjob1: faker.lorem.word(),
        deslstpos: faker.lorem.words(),
        dtestart: moment().format('DD/MM/YYYY'),
        dteend: moment().format('DD/MM/YYYY'),
        desres: faker.lorem.sentence(),
        wrk_location: faker.lorem.words(),
        telnum: Math.floor((Math.random() * 900000000) + 1),
        leader: faker.lorem.word(),
        salnow: Math.floor((Math.random() * 900000000) + 1),
        remark: faker.lorem.word()
      })
    }

    let mockTab8 = {
      // subtopic1
      namfathr: faker.lorem.word(),
      numofidf: Math.floor((Math.random() * 9000000000000) + 1),
      codfrelg: faker.lorem.word(),
      codfnatn: faker.lorem.word(),
      codfoccu: faker.lorem.word(),
      // subtopic2
      nammothr: faker.lorem.word(),
      numofidm: Math.floor((Math.random() * 9000000000000) + 1),
      codmrelg: faker.lorem.word(),
      codmnatn: faker.lorem.word(),
      codmoccu: faker.lorem.word(),
      // subtopic3
      namcont: faker.lorem.word(),
      desrelat: faker.lorem.word(),
      adrcont1: faker.lorem.word(),
      codpost: Math.floor((Math.random() * 90000) + 1),
      numtele: Math.floor((Math.random() * 9000000000) + 1),
      numfax: Math.floor((Math.random() * 9000000000) + 1),
      email: faker.lorem.word()
    }

    let mockTab9 = {
      // subtopic1
      namspous: faker.lorem.word(),
      numoffid: Math.floor((Math.random() * 9000000000000) + 1),
      codspocc: faker.lorem.word(),
      dtespbd: moment().format('DD/MM/YYYY'),
      desnoffi: faker.lorem.word(),
      // subtopic2
      dtemarry: moment().format('DD/MM/YYYY'),
      codsppro: faker.lorem.word(),
      codspcty: faker.lorem.word(),
      desplreg: faker.lorem.word(),
      desnote: faker.lorem.word(),
      idf: Math.floor((Math.random() * 9000000000000) + 1),
      idm: Math.floor((Math.random() * 9000000000000) + 1)
    }

    let mockTab10ChildDataRows = []
    const mockTab10ChildDataTotal = Math.floor((Math.random() * 5) + 1)
    for (i = 1; i <= mockTab10ChildDataTotal; i++) {
      mockTab10ChildDataRows.push({
        numseq: i,
        namchild: faker.lorem.words(),
        numoffid: Math.floor((Math.random() * 1000000000) + 1),
        dtechbd: moment().format('DD/MM/YYYY'),
        codsex: faker.lorem.word(),
        desflgedlv: faker.lorem.word(),
        desflgded: faker.lorem.words()
      })
    }

    let mockTab11GuarantorRows = []
    const mockTab11GuarantorTotal = Math.floor((Math.random() * 4) + 1)
    for (i = 1; i <= mockTab11GuarantorTotal; i++) {
      mockTab11GuarantorRows.push({
        numseq: i,
        namguar: faker.lorem.words(),
        dtegucon: moment().format('DD/MM/YYYY'),
        dteguexp: moment().format('DD/MM/YYYY'),
        desrelat: faker.lorem.word(),
        desoccup: faker.lorem.word()
      })
    }

    let mockTab12AssetDataRows = []
    const mockTab12AssetDataTotal = Math.floor((Math.random() * 4) + 1)
    for (i = 1; i <= mockTab12AssetDataTotal; i++) {
      mockTab12AssetDataRows.push({
        numseq: i,
        numcolla: faker.address.stateAbbr(),
        descolla: faker.lorem.words(),
        amtcolla: Math.floor((Math.random() * 100000000) + 1),
        numdocum: Math.floor((Math.random() * 1000) + 1)
      })
    }

    let mockTab13TalentTypeRows = []
    const mockTab13TalentTypeTotal = Math.floor((Math.random() * 4) + 2)
    for (i = 1; i <= mockTab13TalentTypeTotal; i++) {
      mockTab13TalentTypeRows.push({
        numseq: i,
        typtency: faker.address.stateAbbr() + faker.address.stateAbbr(),
        desc_typtency: faker.lorem.words()
      })
    }

    let mockTab13TalentDataRows = []
    const mockTab13TalentDataTotal = Math.floor((Math.random() * 4) + 2)
    for (i = 0; i < mockTab13TalentDataTotal * mockTab13TalentTypeTotal; i++) {
      let mockType = i % mockTab13TalentTypeTotal
      mockTab13TalentDataRows.push({
        numseq: i,
        typtency: mockTab13TalentTypeRows[mockType]['typtency'],
        codtency: faker.address.stateAbbr() + faker.address.stateAbbr(),
        desc_codtency: faker.lorem.words(),
        fscore: Math.floor((Math.random() * 10) + 6),
        score: Math.floor((Math.random() * 5) + 1)
      })
    }

    let mockTab14TrainingDataRows = []
    const mockTab14TrainingDataTotal = Math.floor((Math.random() * 4) + 1)
    for (i = 1; i <= mockTab14TrainingDataTotal; i++) {
      mockTab14TrainingDataRows.push({
        numseq: i,
        destrain: faker.lorem.words(),
        dtetrain: moment().format('DD/MM/YYYY'),
        dtetren: moment().format('DD/MM/YYYY'),
        desplace: faker.lorem.words(),
        desinstu: faker.lorem.words()
      })
    }

    let mockTab15HonorsDataRows = []
    const mockTab15HonorsDataTotal = Math.floor((Math.random() * 4) + 1)
    for (i = 1; i <= mockTab15HonorsDataTotal; i++) {
      mockTab15HonorsDataRows.push({
        numseq: i,
        dteinput: moment().format('DD/MM/YYYY'),
        typrewd: faker.lorem.words(),
        desrewd1: faker.lorem.words(),
        numhmref: Math.floor((Math.random() * 1000) + 1)
      })
    }

    let mockTab16ChangeNameRows = []
    const mockTab16ChangeNameTotal = Math.floor((Math.random() * 4) + 1)
    for (i = 1; i <= mockTab16ChangeNameTotal; i++) {
      mockTab16ChangeNameRows.push({
        numseq: i,
        dtechg: moment().format('DD/MM/YYYY'),
        namtitle: faker.name.prefix(),
        namfirste: faker.name.firstName(),
        namlaste: faker.name.lastName(),
        deschang: faker.lorem.words()
      })
    }

    let mockTab17DocumentRows = []
    const mockTab17DocumentTotal = Math.floor((Math.random() * 4) + 1)
    for (i = 1; i <= mockTab17DocumentTotal; i++) {
      mockTab17DocumentRows.push({
        numseq: i,
        typdoc: faker.lorem.word(),
        namdoc: faker.lorem.word(),
        dterecv: moment().format('DD/MM/YYYY'),
        dtedocen: moment().format('DD/MM/YYYY'),
        numdoc: Math.floor((Math.random() * 1000) + 1),
        filedoc: faker.lorem.word(),
        path_filedoc: faker.lorem.word(),
        desnote: faker.lorem.sentence()
      })
    }

    let mockTab18PersonRefRows = []
    const mockTab18PersonRefTotal = Math.floor((Math.random() * 4) + 1)
    for (i = 1; i <= mockTab18PersonRefTotal; i++) {
      mockTab18PersonRefRows.push({
        numseq: i,
        namref: faker.name.firstName(),
        flgref: faker.lorem.word(),
        desnoffi: faker.lorem.word(),
        despos: faker.lorem.words(),
        numtele: Math.floor((Math.random() * 1000000) + 1),
        adrcont1: faker.lorem.sentence(),
        email: faker.lorem.word(),
        codoccup: faker.lorem.word(),
        remark: faker.lorem.words()
      })
    }

    let mockTab19EtcDataRows = []
    const mockTab19EtcDataTotal = Math.floor((Math.random() * 3) + 1)
    for (i = 1; i <= mockTab19EtcDataTotal; i++) {
      mockTab19EtcDataRows.push({
        numseq: i,
        desother: faker.lorem.word(),
        desvalue: faker.lorem.words()
      })
    }

    return {
      tab2: mockTab2,
      tab3: mockTab3,
      tab4: {
        tableIncome: {
          total: mockTab4IncomeTotal,
          rows: mockTab4IncomeRows
        },
        detail: mockTab4Detail
        // tableSummary: {
        //   total: mockTab4SummaryTotal,
        //   rows: mockTab4SummaryRows
        // }
      },
      tab5: {
        detail: mockTab5Detail,
        tableTaxExemption: {
          total: mockTab5TaxExemptionTotal,
          rows: mockTab5TaxExemptionRows
        },
        tableTaxDeduction: {
          total: mockTab5TaxDeductionTotal,
          rows: mockTab5TaxDeductionRows
        },
        tableOtherDeduction: {
          total: mockTab5OtherDeductionTotal,
          rows: mockTab5OtherDeductionRows
        }
      },
      tab6: {
        tableEducation: {
          total: mockTab6EducationTotal,
          rows: mockTab6EducationRows
        }
      },
      tab7: {
        tableExpWork: {
          total: mockTab7ExpWorkTotal,
          rows: mockTab7ExpWorkRows
        }
      },
      tab8: mockTab8,
      tab9: mockTab9,
      tab10: {
        tableChildData: {
          total: mockTab10ChildDataTotal,
          rows: mockTab10ChildDataRows
        }
      },
      tab11: {
        tableGuarantor: {
          total: mockTab11GuarantorTotal,
          rows: mockTab11GuarantorRows
        }
      },
      tab12: {
        tableAssetData: {
          total: mockTab12AssetDataTotal,
          rows: mockTab12AssetDataRows
        }
      },
      tab13: {
        tableTalentType: {
          total: mockTab13TalentTypeTotal,
          rows: mockTab13TalentTypeRows
        },
        tableTalentData: {
          total: mockTab13TalentDataTotal,
          rows: mockTab13TalentDataRows
        }
      },
      tab14: {
        tableTrainingData: {
          total: mockTab14TrainingDataTotal,
          rows: mockTab14TrainingDataRows
        }
      },
      tab15: {
        tableHonorsData: {
          total: mockTab15HonorsDataTotal,
          rows: mockTab15HonorsDataRows
        }
      },
      tab16: {
        tableChangeName: {
          total: mockTab16ChangeNameTotal,
          rows: mockTab16ChangeNameRows
        }
      },
      tab17: {
        tableDocument: {
          total: mockTab17DocumentTotal,
          rows: mockTab17DocumentRows
        }
      },
      tab18: {
        tablePersonRef: {
          total: mockTab18PersonRefTotal,
          rows: mockTab18PersonRefRows
        }
      },
      tab19: {
        tableEtcData: {
          total: mockTab19EtcDataTotal,
          rows: mockTab19EtcDataRows
        }
      }
    }
  },
  detailTab13Popup () {
    let mockRows = []
    const mockTotal = Math.floor((Math.random() * 4) + 2)
    for (let i = 1; i <= mockTotal; i++) {
      mockRows.push({
        group: faker.address.stateAbbr(),
        desc_group: faker.lorem.words(),
        score: Math.floor(Math.random() * 100)
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hres31x/mocker.js